import React from 'react';

export const Bell = () => {
	return (
		<svg
			fill='none'
			version='1.1'
			viewBox='0 0 177 112'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g>
				<circle cx='89' cy='73' r='65' fill='#fff' />
			</g>
			<g filter='url(#filter0_d_9561_11628)'>
				<path
					d='m122.8 85.25c0 1.4421-0.573 2.8251-1.593 3.8449-1.02 1.0197-2.403 1.5926-3.845 1.5926h-55.734c-1.4421 0-2.8252-0.5729-3.8449-1.5926-1.0197-1.0198-1.5926-2.4028-1.5926-3.8449 0-1.4422 0.5729-2.8252 1.5926-3.8449 1.0197-1.0198 2.4028-1.5926 3.8449-1.5926h2.0391v-21.75c0.0079-5.4165 1.7185-10.693 4.8897-15.084 3.1713-4.391 7.6428-7.6739 12.782-9.3844 5.2924-1.776 11.02-1.776 16.312 0 5.1398 1.7105 9.6108 4.9934 12.782 9.3844 3.172 4.391 4.882 9.6679 4.89 15.084v21.75h2.039c1.442 0 2.825 0.5728 3.845 1.5926 1.02 1.0197 1.593 2.4027 1.593 3.8449z'
					fill='#BEDCFF'
				/>
				<path
					d='m97.656 30.875v2.7188c-5.2924-1.776-11.02-1.776-16.312 0v-2.7188c0-2.1632 0.8593-4.2377 2.3889-5.7673s3.6041-2.3889 5.7673-2.3889 4.2377 0.8593 5.7673 2.3889 2.3889 3.6041 2.3889 5.7673z'
					fill='#FCD8AA'
				/>
				<path
					d='m103.09 90.688c0 3.6053-1.432 7.0629-3.9818 9.6125-2.5493 2.549-6.0069 3.981-9.6122 3.981s-7.0629-1.432-9.6122-3.981c-2.5494-2.5496-3.9816-6.0072-3.9816-9.6125h27.188z'
					fill='#E99F49'
				/>
				<path
					d='m61.632 93.406h11.799c0.6623 3.7807 2.6365 7.2068 5.5754 9.6758 2.9388 2.469 6.6541 3.822 10.492 3.822 3.8382 0 7.5535-1.353 10.492-3.822 2.9393-2.469 4.9133-5.8951 5.5753-9.6758h11.799c1.072 0.0447 2.141-0.1221 3.148-0.4908 1.006-0.3686 1.93-0.9319 2.719-1.6578 0.789-0.7258 1.428-1.5999 1.879-2.5724 0.451-0.9724 0.706-2.0243 0.751-3.0954 0.044-1.071-0.123-2.1404-0.491-3.1471-0.369-1.0066-0.932-1.9308-1.658-2.7197-0.726-0.789-1.6-1.4272-2.572-1.8783-0.973-0.4512-2.025-0.7063-3.096-0.7509v-19.031c0.011-3.7484-0.723-7.4616-2.158-10.924-1.435-3.4629-3.543-6.6065-6.202-9.2487-2.663-2.672-5.828-4.7923-9.312-6.2396v-0.7748c0-2.8842-1.1455-5.6503-3.1849-7.6898-2.0395-2.0394-4.8056-3.1852-7.6898-3.1852-2.8843 0-5.6504 1.1458-7.6898 3.1852-2.0395 2.0395-3.1852 4.8056-3.1852 7.6898v0.802c-5.2274 2.1538-9.6974 5.8112-12.844 10.509-3.1461 4.6974-4.8266 10.223-4.8283 15.877v19.031c-2.1632 0.0901-4.2019 1.0358-5.6678 2.6292-1.4659 1.5933-2.2387 3.7037-2.1486 5.8668 0.0901 2.1632 1.0359 4.202 2.6292 5.6678 1.5933 1.4659 3.7037 2.2388 5.8669 2.1486zm27.867 8.1558c-2.4096-1e-3 -4.7503-0.803-6.6547-2.2795-1.9043-1.4763-3.2645-3.5432-3.8669-5.8763h21.043c-0.6026 2.3331-1.9627 4.4-3.8671 5.8763-1.9044 1.4765-4.2451 2.2785-6.6546 2.2795zm0-76.124c1.2933 0.0038 2.5429 0.4684 3.5245 1.3105s1.6309 2.0065 1.8314 3.2842c-1.7646-0.3434-3.5582-0.5164-5.3559-0.5166-1.7975 0.0057-3.5906 0.1786-5.356 0.5166 0.2005-1.2777 0.8498-2.4421 1.8314-3.2842s2.2313-1.3067 3.5246-1.3105zm-29.811 57.896c0.2545-0.2561 0.5575-0.4589 0.8912-0.5966 0.3338-0.1377 0.6916-0.2075 1.0527-0.2055h2.039c0.7211 0 1.4126-0.2864 1.9225-0.7963 0.5099-0.5098 0.7963-1.2013 0.7963-1.9224v-21.75c0.0111-4.5624 1.3725-9.0194 3.9126-12.809 2.54-3.79 6.1451-6.7432 10.361-8.4877 4.2157-1.7444 8.8535-2.202 13.329-1.3149 4.4754 0.887 8.5879 3.0789 11.82 6.2994 2.156 2.1335 3.868 4.6741 5.035 7.4744 1.166 2.8003 1.765 5.8045 1.762 8.8381v21.75c0 0.7211 0.286 1.4126 0.796 1.9224 0.51 0.5099 1.201 0.7963 1.922 0.7963h2.039c0.722 0 1.413 0.2865 1.923 0.7964 0.51 0.5098 0.796 1.2013 0.796 1.9224s-0.286 1.4126-0.796 1.9224c-0.51 0.5099-1.201 0.7964-1.923 0.7964h-55.734c-0.7211 0-1.4126-0.2865-1.9225-0.7964-0.5098-0.5098-0.7963-1.2013-0.7963-1.9224-0.0042-0.716 0.2743-1.4048 0.7749-1.9167zm10.25-51.017-3.3985-4.2412c-5.8797 4.7031-10.154 11.115-12.234 18.352l5.22 1.5224c1.767-6.164 5.4057-11.627 10.413-15.633zm49.576 15.633 5.22-1.5224c-2.08-7.2363-6.354-13.648-12.234-18.352l-3.399 4.2412c5.008 4.006 8.646 9.4688 10.413 15.633z'
					fill='#474C54'
				/>
			</g>
			<g fill='#474C54'>
				<rect
					x='158'
					y='70'
					width='18.795'
					height='6.2651'
					rx='3.1325'
				/>
				<rect
					transform='rotate(-15 152 36.865)'
					x='152'
					y='36.865'
					width='18.795'
					height='6.2651'
					rx='3.1325'
					opacity='.8'
				/>
				<rect
					transform='rotate(15 152 103)'
					x='152'
					y='103'
					width='18.795'
					height='6.2651'
					rx='3.1325'
					opacity='.8'
				/>
				<rect y='70' width='18.795' height='6.2651' rx='3.1325' />
				<rect
					transform='rotate(-15 7 108)'
					x='7'
					y='108'
					width='18.795'
					height='6.2651'
					rx='3.1325'
					opacity='.8'
				/>
				<rect
					transform='rotate(15 10.621 32)'
					x='10.621'
					y='32'
					width='18.795'
					height='6.2651'
					rx='3.1325'
					opacity='.8'
				/>
			</g>
			<defs>
				<filter
					id='filter0_d_9561_11628'
					x='46'
					y='20'
					width='87'
					height='90.132'
					colorInterpolationFilters='sRGB'
					filterUnits='userSpaceOnUse'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						result='hardAlpha'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
					/>
					<feOffset dy='3.13253' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0' />
					<feBlend
						in2='BackgroundImageFix'
						result='effect1_dropShadow_9561_11628'
					/>
					<feBlend
						in='SourceGraphic'
						in2='effect1_dropShadow_9561_11628'
						result='shape'
					/>
				</filter>
			</defs>
		</svg>
	);
};
